import styled from "@emotion/styled";
import { ursaColors } from "@smartsheet/design-tokens";
import { neutralDark20 } from "../../../constants/colors";
import { sizes } from "../../../constants/spacing";
import { RequiredThemeKeys, themed } from "../../../util/theme";
import { TypeRampV2 } from "../../typography";

const descriptionStyles = themed({
    color: {
        "lodestar-light": neutralDark20,
        "ursa-light": ursaColors.neutral600,
    },
});

interface FormLabelDescriptionProps {
    themeMode: RequiredThemeKeys;
}

export const FormLabelDescription = styled(TypeRampV2)<FormLabelDescriptionProps>`
    color: ${({ themeMode }) => descriptionStyles.color(themeMode)};
    &:not(:empty) {
        margin-bottom: ${sizes.xSmall}px;
        margin-top: ${sizes.xxSmall}px;
        label + & {
            margin-top: -${sizes.xxSmall}px;
        }
    }
`;
